import { useEffect, useMemo, useState } from 'react';
import { getCourses } from '../services/courses';
import { mapCourse } from '../utils/dashboardMappers';

export function useCoursesBySubjects({ subjectIds = [], subcategoryId, enabled = true }) {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(Boolean(enabled && subjectIds.length));
  const [error, setError] = useState(null);

  const subjectKey = useMemo(() => JSON.stringify(subjectIds), [subjectIds]);

  useEffect(() => {
    if (!enabled || !subjectIds.length) {
      setCourses([]);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    Promise.all(
      subjectIds.map((subjectId) =>
        getCourses({ subject_id: subjectId, sort: 'desc' }).then((res) => res?.data?.courses || [])
      )
    )
      .then((results) => {
        if (cancelled) return;

        const merged = results.flat();
        const unique = Array.from(new Map(merged.map((course) => [course.id, course])).values());
        const filtered = subcategoryId
          ? unique.filter((course) => String(course.subcategory_id) === String(subcategoryId))
          : unique;

        setCourses(filtered.map(mapCourse).filter(Boolean));
      })
      .catch((e) => {
        if (!cancelled) {
          setError(e?.message || 'Failed to load courses');
          setCourses([]);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [subjectKey, subcategoryId, enabled]);

  return { courses, loading, error };
}
